import { Outlet, Navigate, useLocation } from 'react-router-dom';

const NewPasswordProtectedRoute = () => {
  const route = useLocation();
  const tokenAndEmail = route.search.replace('?token=', '');

  return tokenAndEmail ? <Outlet /> : <Navigate to='/' />;
};

export default NewPasswordProtectedRoute;
